/**
 * Entorno de STAGING — https://test-whatsapp.urbanor.com.bo
 *
 * Se compila con `ng build --configuration staging` (ver angular.json).
 *
 * UN SOLO DOMINIO. A diferencia de producción, que reparte frontend y API en
 * dos subdominios, aquí Nginx sirve el frontend estático en la raíz y hace de
 * proxy inverso hacia el backend bajo /api. De ahí las dos URLs de abajo:
 *
 *  · apiUrl lleva /api  → Nginx quita ese prefijo antes de reenviar, así que
 *    el backend sigue viendo /auth/login, /conversations, etc. sin cambios.
 *  · wsUrl NO lo lleva  → Socket.IO usa su propia ruta (/socket.io), que Nginx
 *    proxya aparte. SocketService ya contempla este montaje: hace
 *    `apiUrl.replace('/api', '')` cuando wsUrl no está definida.
 *
 * Consecuencia a tener presente: en staging todo es mismo origen, así que los
 * fallos de CORS y de alcance de cookies entre subdominios NO se reproducen
 * aquí. Son justo los que hay que revisar a mano antes de pasar a producción.
 *
 * Firebase apunta al MISMO proyecto que producción. Es seguro porque las
 * notificaciones push van a los tokens guardados en la tabla
 * `notification_tokens` de la BD, y la BD de staging arranca con esa tabla
 * VACÍA (ver deploy/anonimizar-staging.sql). Si algún día se restaura un dump
 * de producción sin ese paso, staging mandaría push a los móviles reales de los
 * agentes.
 */
export const environment = {
    production: true,
    apiUrl: 'https://test-whatsapp.urbanor.com.bo/api',
    wsUrl: 'wss://test-whatsapp.urbanor.com.bo',

    /**
     * Servidores ICE para las llamadas de WhatsApp (WebRTC).
     *
     * Mismo pendiente que en producción: falta el TURN propio. El STUN solo
     * descubre la IP pública; tras NAT simétrico o el firewall de una oficina
     * el audio no pasa y el síntoma es traicionero — la llamada aparece como
     * activa y no se oye a nadie, sin error en ninguna parte. Al montar coturn,
     * añadir aquí y en environment.prod.ts:
     *   { urls: 'turn:turn.urbanor.com.bo:3478', username: '…', credential: '…' }
     */
    iceServers: [
        { urls: 'stun:stun.l.google.com:19302' }
    ] as RTCIceServer[],

    /**
     * Google OAuth Client ID — el MISMO que producción. Para que el botón de
     * "Iniciar sesión con Google" funcione aquí hay que añadir
     * https://test-whatsapp.urbanor.com.bo a los "Orígenes de JavaScript
     * autorizados" de esa credencial en Google Cloud Console. Sin ese paso el
     * login con Google devuelve un error 400 de origen no permitido.
     */
    googleClientId: '1024412747779-l12gdu2ska2o53uurabgicvaipaq7t0g.apps.googleusercontent.com',

    /**
     * Firebase/FCM Config — REQUIRED for PWA Push Notifications.
     * Go to Firebase Console > Project Settings > General to find these.
     */
    firebaseConfig: {
        apiKey: 'AIzaSyCAT9WATztEqa5rhfVCGNcxHsUF_dzEVtw',
        authDomain: 'whatsapp-urbanor.firebaseapp.com',
        projectId: 'whatsapp-urbanor',
        storageBucket: 'whatsapp-urbanor.firebasestorage.app',
        messagingSenderId: '618441400825',
        appId: '1:618441400825:web:5310f82fdbf0cebb7e9d28',
        measurementId: 'G-2MJJD1QM5D'
    },

    /**
     * VAPID Public Key.
     * Find in Firebase Console > Project Settings > Cloud Messaging > Web Push Certificates.
     */
    vapidKey: 'BJu0Bgh4tqAK3dyZr9rPWU9C03eTCPfBDZQG4c3-s7yhEGMxrDs5VHoyVR3BFIooe2TKMsuCVAdteHxh2pEixSU'
};
